export default ({ yAxisGridLineWidth = 1 }) => {
    return {
        yAxis: {
            gridLineWidth: yAxisGridLineWidth,
        },
    };
};
